"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Columns = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
function Columns(_a) {
    var children = _a.children, _b = _a.gap, gap = _b === void 0 ? 0 : _b;
    if (!children || (children && !children.length))
        return null;
    var count = children && children.length;
    return (react_1.default.createElement(StyledColumns, null, react_1.default.Children.map(children, function (child) { return (react_1.default.createElement(StyledColumn, { key: child.key || undefined, count: count, gap: gap }, child)); })));
}
exports.Columns = Columns;
var StyledColumns = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  @media screen and (min-width: 800px) {\n    display: flex;\n    align-items: start;\n  }\n"], ["\n  @media screen and (min-width: 800px) {\n    display: flex;\n    align-items: start;\n  }\n"])));
var StyledColumn = styled_components_1.default.div(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  width: 100%;\n  @media screen and (min-width: 800px) {\n    width: ", ";\n    margin-left: ", ";\n    &:first-child {\n      margin-left: 0;\n    }\n  }\n  @media screen and (max-width: 799px) {\n    margin-top: ", ";\n    &:first-child {\n      margin-top: 0;\n    }\n  }\n"], ["\n  width: 100%;\n  @media screen and (min-width: 800px) {\n    width: ", ";\n    margin-left: ", ";\n    &:first-child {\n      margin-left: 0;\n    }\n  }\n  @media screen and (max-width: 799px) {\n    margin-top: ", ";\n    &:first-child {\n      margin-top: 0;\n    }\n  }\n"])), function (_a) {
    var count = _a.count;
    return "".concat(100 / count, "%");
}, function (_a) {
    var gap = _a.gap;
    return "".concat(gap, "px");
}, function (_a) {
    var gap = _a.gap;
    return "".concat(gap, "px");
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map